import type { IconData } from '@stacksjs/iconify-core'

export const checkAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M200.359 382.269L61.057 251.673l21.886-23.346l116.698 109.404l229.045-229.044l22.628 22.626z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default checkAlt
